import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountLocatorRule  {
    _originalTypeClassName = "zERP.BO.AccountLocatorRule";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountLocatorRule.translate = translateService;
}
this.Inputs = [];
this.Context = [];
this.Parts = [];
this.Components = [];
this.AvailableFor = [];
this.Conditions = [];
this.Id = null;
this.Name = null;
this.Type = null;
this.CreateAccountIfNotFound = false;
this.AccountNameMethod = null;
this.AccountName = null;
this.AccountNameProperty = null;
this.AllowMultipleSelection = false;
this.RootAccountId = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Type:any;
CreateAccountIfNotFound:any;
AccountNameMethod:any;
AccountName:any;
AccountNameProperty:any;
AllowMultipleSelection:any;
RootAccountId:any;
Ledger:any;
Inputs:any;
Context:any;
Parts:any;
Components:any;
MainEntity:any;
AvailableFor:any;
Conditions:any;
static setLedger = ($this, value) => {
var oldValue = $this.Ledger;
$this.Ledger = value;
if (value != null) {
}
}
static setInputs = ($this, items) => {
                if (items == null) items = [];
                if ($this.Inputs == null) $this.Inputs = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Inputs.length > 0) {
                    Domain.AccountLocatorRule.removeInputs($this, $this.Inputs[0]);
                }

                Domain.AccountLocatorRule.addManyInputs($this, copyItems);
            }
static addManyInputs = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountLocatorRule.addInputs($this, items[i]);
                }
            }
static addInputs = ($this, item) => {
                if ($this.Inputs == null) $this.Inputs = [];
                if (item == null || $this.Inputs.indexOf(item) > -1) return;
                $this.Inputs.push(item);
}
static addRangeInputs = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountLocatorRule.addInputs($this, item));
            }
static removeInputs = ($this, item) => {
                if ($this == null || $this.Inputs == null || $this.Inputs.indexOf(item) === -1) return;
                var _index = $this.Inputs.indexOf(item);
                $this.Inputs.splice(_index, 1);
}
static clearInputs = ($this) => { $this.Inputs = null; }
static setContext = ($this, items) => {
                if (items == null) items = [];
                if ($this.Context == null) $this.Context = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Context.length > 0) {
                    Domain.AccountLocatorRule.removeContext($this, $this.Context[0]);
                }

                Domain.AccountLocatorRule.addManyContext($this, copyItems);
            }
static addManyContext = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountLocatorRule.addContext($this, items[i]);
                }
            }
static addContext = ($this, item) => {
                if ($this.Context == null) $this.Context = [];
                if (item == null || $this.Context.indexOf(item) > -1) return;
                $this.Context.push(item);
}
static addRangeContext = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountLocatorRule.addContext($this, item));
            }
static removeContext = ($this, item) => {
                if ($this == null || $this.Context == null || $this.Context.indexOf(item) === -1) return;
                var _index = $this.Context.indexOf(item);
                $this.Context.splice(_index, 1);
}
static clearContext = ($this) => { $this.Context = null; }
static setParts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Parts == null) $this.Parts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Parts.length > 0) {
                    Domain.AccountLocatorRule.removeParts($this, $this.Parts[0]);
                }

                Domain.AccountLocatorRule.addManyParts($this, copyItems);
            }
static addManyParts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountLocatorRule.addParts($this, items[i]);
                }
            }
static addParts = ($this, item) => {
                if ($this.Parts == null) $this.Parts = [];
                if (item == null || $this.Parts.indexOf(item) > -1) return;
                $this.Parts.push(item);
}
static addRangeParts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountLocatorRule.addParts($this, item));
            }
static removeParts = ($this, item) => {
                if ($this == null || $this.Parts == null || $this.Parts.indexOf(item) === -1) return;
                var _index = $this.Parts.indexOf(item);
                $this.Parts.splice(_index, 1);
}
static clearParts = ($this) => { $this.Parts = null; }
static setComponents = ($this, items) => {
                if (items == null) items = [];
                if ($this.Components == null) $this.Components = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Components.length > 0) {
                    Domain.AccountLocatorRule.removeComponents($this, $this.Components[0]);
                }

                Domain.AccountLocatorRule.addManyComponents($this, copyItems);
            }
static addManyComponents = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountLocatorRule.addComponents($this, items[i]);
                }
            }
static addComponents = ($this, item) => {
                if ($this.Components == null) $this.Components = [];
                if (item == null || $this.Components.indexOf(item) > -1) return;
                $this.Components.push(item);
}
static addRangeComponents = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountLocatorRule.addComponents($this, item));
            }
static removeComponents = ($this, item) => {
                if ($this == null || $this.Components == null || $this.Components.indexOf(item) === -1) return;
                var _index = $this.Components.indexOf(item);
                $this.Components.splice(_index, 1);
}
static clearComponents = ($this) => { $this.Components = null; }
static setMainEntity = ($this, value) => {
var oldValue = $this.MainEntity;
$this.MainEntity = value;
if (value != null) {
}
}
static setAvailableFor = ($this, items) => {
                if (items == null) items = [];
                if ($this.AvailableFor == null) $this.AvailableFor = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AvailableFor.length > 0) {
                    Domain.AccountLocatorRule.removeAvailableFor($this, $this.AvailableFor[0]);
                }

                Domain.AccountLocatorRule.addManyAvailableFor($this, copyItems);
            }
static addManyAvailableFor = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountLocatorRule.addAvailableFor($this, items[i]);
                }
            }
static addAvailableFor = ($this, item) => {
                if ($this.AvailableFor == null) $this.AvailableFor = [];
                if (item == null || $this.AvailableFor.indexOf(item) > -1) return;
                $this.AvailableFor.push(item);
}
static addRangeAvailableFor = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountLocatorRule.addAvailableFor($this, item));
            }
static removeAvailableFor = ($this, item) => {
                if ($this == null || $this.AvailableFor == null || $this.AvailableFor.indexOf(item) === -1) return;
                var _index = $this.AvailableFor.indexOf(item);
                $this.AvailableFor.splice(_index, 1);
}
static clearAvailableFor = ($this) => { $this.AvailableFor = null; }
static setConditions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Conditions == null) $this.Conditions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Conditions.length > 0) {
                    Domain.AccountLocatorRule.removeConditions($this, $this.Conditions[0]);
                }

                Domain.AccountLocatorRule.addManyConditions($this, copyItems);
            }
static addManyConditions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountLocatorRule.addConditions($this, items[i]);
                }
            }
static addConditions = ($this, item) => {
                if ($this.Conditions == null) $this.Conditions = [];
                if (item == null || $this.Conditions.indexOf(item) > -1) return;
                $this.Conditions.push(item);
}
static addRangeConditions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountLocatorRule.addConditions($this, item));
            }
static removeConditions = ($this, item) => {
                if ($this == null || $this.Conditions == null || $this.Conditions.indexOf(item) === -1) return;
                var _index = $this.Conditions.indexOf(item);
                $this.Conditions.splice(_index, 1);
}
static clearConditions = ($this) => { $this.Conditions = null; }

static CanBeApplied($this: any, vObject: any): any{let objType = CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
if (Joove.Common.stringEndsWith(objType, "Proxy")) {objType = objType?.substr(0, Joove.Common.safeNumber(objType?.length) - Joove.Common.safeNumber(5));}
if (objType == "OtherTransactionItem" || objType == "Asset" || objType == "Good" || objType == "Service") {objType = Domain.GoodBase.GetClassName();}
if ($this?.MainEntity?.ClassName != objType) {return false;}
if (CLMS.Framework.Number.GreaterThan(() => $this.AvailableFor.length, () => 0)) {if (objType == Domain.GoodBase.GetClassName()) {if ((!(Domain.GoodBase.CheckIfCanBeAppliedOnAccounting(vObject, $this?.AvailableFor)))) {console.warn("Skipping due to available for: " + CLMS.Framework.String.Join(", ", $this?.AvailableFor?.linq?.select((s) => s?.SystemName)?.toArray()));return false;}}else if (objType == Domain.TransactionEntity.GetClassName()) {if ((!(Domain.TransactionEntity.CheckIfCanBeAppliedOnAccounting(vObject, $this?.AvailableFor)))) {console.warn("Skipping due to available for: " + CLMS.Framework.String.Join(", ", $this?.AvailableFor?.linq?.select((s) => s?.SystemName)?.toArray()));return false;}}}
console.warn("Step6");
return true;
}
static MatchesConditions($this: any, categories: any): any{if (!($this?.Conditions?.linq?.any())) {return true;console.warn("Step7");}
for (let _icond = 0; _icond < ($this?.Conditions == null ? 0 : $this?.Conditions.length); _icond++) {let cond = $this?.Conditions[_icond];let catMathc = categories?.linq?.where((c) => c?.Category == cond?.Category)?.firstOrDefault(null);if (catMathc == null) {continue;}if (catMathc?.Values?.linq?.any((v) => v == cond?.Value) || (catMathc?.FirstSelectedValue != null && catMathc?.FirstSelectedValue == cond?.Value)) {return true;console.warn("Step7b");}}
console.warn("Step7c");
return false;
}
static SyncParts($this: any): any{if (CLMS.Framework.Number.Equal(() => $this.Ledger.AccountCodeRule.Segments.length, () => $this.Parts.length)) {return;}
$this?.Parts?.splice(0, $this?.Parts.length);
let index = 1;
for (let _isegment = 0; _isegment < ($this?.Ledger?.AccountCodeRule?.Segments == null ? 0 : $this?.Ledger?.AccountCodeRule?.Segments.length); _isegment++) {let segment = $this?.Ledger?.AccountCodeRule?.Segments[_isegment];let part = new Domain.AccountLocatorPart();part.Type = Domain.AccountLocatorType.HardCoded;part.Level = index;index = Joove.Common.safeNumber(index) + Joove.Common.safeNumber(1);$this?.Parts?.add(part);}
}
static UpdateMainEntity($this: any): any{if (CLMS.Framework.Number.Equal(() => $this.Context.length, () => 0)) {Domain.AccountLocatorRule.setMainEntity($this, null);}else {Domain.AccountLocatorRule.setMainEntity($this, $this?.Context[0]?.Entity);}
let first = (CLMS.Framework.Number.Equal(() => $this.Parts.length, () => 0) ? null : $this?.Parts?.linq?.where((p) => p?.Type == Domain.AccountLocatorType.SpecificAccount)?.firstOrDefault(null));
if (first == null || first?.Accounts == null || CLMS.Framework.Number.Equal(() => first.Accounts.length, () => 0)) {$this.RootAccountId = null;}else {$this.RootAccountId = CLMS.Framework.String.Join(", ", first?.Accounts?.linq?.select((a) => a?.ChartOfAccountID)?.toArray());}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}